import { animate, AnimationTriggerMetadata, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';

import { ANIMATIONS } from './animations.data';

/**
 * Animates the :enter event of ngFor
 *
 * @example
 * [@ngForAnimation]="data.length"
 *
 */
export const enterSlideUpAnimation: AnimationTriggerMetadata = trigger('ngForAnimation', [
    transition('* => *', [

        query(':enter', style(
                { opacity: 0 }
            ),
            { optional: true }
        ),

        query(':enter', stagger(ANIMATIONS.speed.default, [
            animate(
                `${ANIMATIONS.speed.slow} ${ANIMATIONS.bezierCurve.default}`,
                keyframes([
                    style({ opacity: 0, transform: 'translateY(10%)' }),
                    style({ opacity: .5, transform: 'translateY(35px)' }),
                    style({ opacity: 1, transform: 'translateY(0)' })
                ])
            )
        ]), { optional: true })
    ])
]);
